import { DateTime } from '@ksyos/date-time';
import { EpisodeCategory, ServiceType } from './enums';

export const acceptatieEmailAddress = 'acceptatietest@ksyos.nl';
export const financialDepartmentEmailAddress = 'finance@ksyos.nl';
export const fourmidableEmailAddress = 'fourmidable@ksyos.nl';
export const aTeamEmailAddress = 'theateam@ksyos.nl';
export const aTeamChannelEmailAddress = 'd8a506c6.ksyos.nl@emea.teams.ms';
export const polikliniekEmailAddress = 'polikliniek@ksyos.nl';
export const privacyOfficerEmailAddress = 'privacy@ksyos.nl';
export const serviceDeskEmailAddress = 'info@ksyos.nl';
export const supportEmailAddress = 'support@ksyos.nl';
export const testEmailAddress = 'test@ksyos.nl';

export const SERIAL_NUMBER_LENGTH = 13;
export const maxDurationSubtrack119Days = 119;
export const maxDurationSubtrack89Days = 89;
export const consultationAndReferral = [ServiceType.consultation, ServiceType.referral];
export const episodeCategoriesWithSpecializations = [
    EpisodeCategory.ophthalmology,
    EpisodeCategory.mentalHealth,
    EpisodeCategory.cardiology,
    EpisodeCategory.dermatology,
];
export const minPatientCount = 0;
export const maxPatientCount = 10_000_000;
export const useVanDerLaarDistributionFromDate = DateTime.from('2023-11-14');
export const thresholdOsasHsdqQuesionnaire = 2.02;

export const unixEpochDate = new Date(1970, 0, 1);

export const maxInt32 = 2147483647;
